module.exports = __webpack_public_path__ + "files/Huisregels.93063d26.pdf";